export function authHeaders(arg = {}) {
  const isObj = typeof arg === 'object' && arg !== null;

  const pick = (obj, keys) => {
    if (!obj) return null;
    for (const k of keys) {
      const v = obj[k];
      if (v !== undefined && v !== null && String(v).trim() !== '') return v;
    }
    return null;
  };

  const normalizeNumericId = (v) => {
    if (v === undefined || v === null) return null;
    const s = String(v).trim();
    if (s === '') return null;
    if (!/^\d+$/.test(s)) return null;
    return s;
  };

  let customerId = null;
  let accessToken = null;

  let session = null;
  try {
    const s = localStorage.getItem('session');
    if (s) session = JSON.parse(s);
  } catch {}

  const sessionCustomerId =
    pick(session, ['customerId', 'customerid', 'customer_id', 'selectedCustomerId', 'tenantCustomerId']) ??
    pick(session?.user, ['customerId', 'customerid', 'customer_id']);

  customerId = normalizeNumericId(sessionCustomerId);

  accessToken =
    pick(session, ['accessToken', 'access_token']) ??
    localStorage.getItem('accessToken') ??
    null;

  if (!customerId) {
    const picked =
      localStorage.getItem('selectedCustomerId') ??
      localStorage.getItem('customerId') ??
      sessionStorage.getItem('selectedCustomerId') ??
      sessionStorage.getItem('customerId');

    customerId = normalizeNumericId(picked);
  }

  if (isObj && 'customerId' in arg) customerId = normalizeNumericId(arg.customerId);
  if (isObj && 'accessToken' in arg) accessToken = arg.accessToken;

  const includeCustomer = isObj && '__skipCustomer' in arg ? !arg.__skipCustomer : true;
  const includeAuth = isObj && '__skipAuth' in arg ? !arg.__skipAuth : true;
  const includeContentType = isObj && ('multipart' in arg || '__skipContentType' in arg)
    ? !arg.multipart && !arg.__skipContentType
    : true;

  const headers = { Accept: 'application/json' };
  if (includeContentType) headers['Content-Type'] = 'application/json';

  if (includeAuth && accessToken) headers['Authorization'] = `Bearer ${accessToken}`;
  if (includeCustomer && customerId) headers['X-Customer-Id'] = String(customerId);

  return headers;
}
